/* eslint-disable jsx-a11y/media-has-caption */
import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useRef } from 'react'
import { ThemeProvider } from 'theming'
import { gsap } from 'gsap'

import staggerAnimation from '../../utils/staggerAnimation'
import withMemo from '../../decorators/withMemo'
import Icon from '../Icon'
import { iconsKeys } from '../Icon/Icon.assets'
import AccessibleHiddenText from '../AccessibleHiddenText'
import Layout from '../Layout'

import useStyles from './styles'


const LayoutGame = (props) => {
  const classes = useStyles(props)
  const { className, title, children, navigation, theme, videoBackgroundSources, seo, withHeader } = props

  // animations
  const $animatedWrapper = useRef()

  useEffect(() => {
    const timeline = gsap.timeline()

    if ($animatedWrapper.current) {
      const animatedChildren = Array.from($animatedWrapper.current.children).filter((child) => !child.classList.contains('is-notstaggered'))

      staggerAnimation(0, animatedChildren, timeline, 0.5, '+=0.2', 0.5)
      timeline.play()
    }
    // cleanup
    return () => {
      timeline.clear()
    }
  }, [])

  return (
    <Layout seo={seo}>
      <ThemeProvider theme={theme}>
        <main className={cx(className, classes.container)}>
          <div
            className={classes.wrapper}
            ref={$animatedWrapper}
          >
            <header className={classes.header}>
              {withHeader && (
                <>
                  <AccessibleHiddenText text={title} />
                  <Icon
                    icon={iconsKeys.Logo}
                    className={classes.logoMain}
                    aria-hidden="true"
                  />
                </>
              )}
            </header>
            {children}
            {navigation}
          </div>
          {videoBackgroundSources && (
            <div
              className={classes.background}
              aria-hidden="true"
            >
              <video
                className={classes.video}
                loop
                muted
                playsInline
                autoPlay
                preload="preload"
              >
                {videoBackgroundSources.map((source, index) => (
                  <source
                    key={`backgroundVideo-${index}`}
                    src={source.src}
                    type={source.type}
                  />
                ))}
              </video>
            </div>
          )}
        </main>
      </ThemeProvider>
    </Layout>
  )
}

export const LayoutGamePropTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  navigation: PropTypes.node,
  // eslint-disable-next-line react/forbid-prop-types
  theme: PropTypes.object,
  videoBackgroundSources: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      type: PropTypes.string,
    })
  ),
  seo: PropTypes.objectOf(PropTypes.string),
  withHeader: PropTypes.bool,
}

LayoutGame.propTypes = LayoutGamePropTypes

LayoutGame.defaultProps = {
  className: null,
  title: 'Balenciaga',
  navigation: null,
  theme: null,
  videoBackgroundSources: null,
  seo: {},
  withHeader: true,
}

export default withMemo()(LayoutGame)
